import React, { SVGProps } from 'react'

export const PatientListIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
    <g clipPath="url(#a)">
      <mask
        id="b"
        width={24}
        height={24}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'alpha',
        }}
      >
        <path fill="#D9D9D9" d="M0 0h24v24H0z" />
      </mask>
      <g mask="url(#b)">
        <path
          fill="#0D58D9"
          d="M16 14a2.893 2.893 0 0 1-2.125-.875A2.893 2.893 0 0 1 13 11c0-.833.292-1.542.875-2.125A2.893 2.893 0 0 1 16 8c.833 0 1.542.292 2.125.875S19 10.167 19 11s-.292 1.542-.875 2.125A2.893 2.893 0 0 1 16 14Zm-6 6v-1.9c0-.35.083-.683.25-1 .167-.317.4-.567.7-.75a9.273 9.273 0 0 1 2.388-1.013A10.27 10.27 0 0 1 16 15c.933 0 1.82.113 2.663.338a9.273 9.273 0 0 1 2.387 1.012c.3.183.533.433.7.75.167.317.25.65.25 1V20H10Zm2.15-2h7.7a7.436 7.436 0 0 0-1.85-.75 8.019 8.019 0 0 0-2-.25c-.683 0-1.35.083-2 .25a7.436 7.436 0 0 0-1.85.75ZM16 12c.283 0 .52-.096.712-.287A.968.968 0 0 0 17 11a.968.968 0 0 0-.288-.713A.968.968 0 0 0 16 10a.968.968 0 0 0-.713.287A.968.968 0 0 0 15 11c0 .283.096.52.287.713.192.191.43.287.713.287ZM3 14v-2h8v2H3Zm0-8V4h12v2H3Zm8.1 4H3V8h9c-.233.283-.42.592-.563.925A5.997 5.997 0 0 0 11.1 10Z"
        />
      </g>
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
)
